var map = {
	"./DaxExch-logo.png": 1480,
	"./Fairplay_New_Logo.png": 1481,
	"./Fairplay_New_Logo_l.png": 1482,
	"./MatrixExch-logo.png": 1483,
	"./MatrixExch-logo_w.png": 1484,
	"./PlayExch-logo.png": 1485,
	"./PlayExch-logo_w.png": 1486,
	"./ZeExch-logo.png": 1487,
	"./ZodExch-logo.png": 1488,
	"./ZodExch-logo1.png": 1489,
	"./fairnews-logo.png": 1490,
	"./fairplay-website-logo.png": 186,
	"./menu.png": 653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1479;